import { Link } from 'react-router';
import { SITE } from '~/data/site';

/**
 * Sticky bottom bar, mobile only.
 *
 * 81% of visits in this vertical are mobile, and mobile converts about 40% worse
 * than desktop. The single best mobile element in the 17-site audit was Jan-Pro's
 * persistent bottom bar, so this is that pattern: quote, email, pricing — the three
 * things a facility manager on a phone actually wants.
 */
export function ActionBar() {
  return (
    <nav className="action-bar" aria-label="Quick actions">
      <Link to="/quote" className="is-primary">
        Get a quote
      </Link>
      <a href={`mailto:${SITE.contact.email}`}>Email us</a>
      <Link to="/pricing">Pricing</Link>
    </nav>
  );
}
